// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Rdn-","title":"Info_title__1GEj3","links":"Info_links__3vS8I","link":"Info_link__1ENBU","logo":"Info_logo__1h1Hg"};